/* eslint-disable unicorn/prefer-module */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable arrow-body-style */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Header } from "../Header";
import { useAuthContext } from "../../context/auth";
import { ROLES } from "../../constants/roles";
import { getEdificios, updateEdificio, saveEdificio, getCategorias } from "../../utils";
import { crearActivo, getActivos, eliminarActivo } from "../../utils/activos";
import { getProveedores } from "../../utils/proveedores";

import { EdificiosChartModal } from "./EdificiosChartModal";
import styles from "./EdificiosTable.module.scss";

const EdificiosTable = ({ pais: propPais }) => {
  const [categorias, setCategorias] = useState();
  const [edificios, setEdificios] = useState([]);
  const [editMode, setEditMode] = useState(null); // Estado para controlar el modo edición
  const [editedEdificio, setEditedEdificio] = useState(null); // Estado para almacenar los datos editados
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newEdificio, setNewEdificio] = useState({
    edificio: "",
    estado: "",
    alianza: "",
    personas: "",
    pantallas: "",
    totems: "",
    espera: "",
    programatica: "Sí",
    estacionamientos: "",
    estacionamientos_ocupacion: "",
    ubicacion: "",
    direccion: "",
    lat: "",
    lng: "",
    empresaslistado: "",
    empresasdestacadas: "",
    vetos: "",
    comision_1_porcentaje: "",
    comision_1_fechainicio: "",
    comision_1_fechafin: "",
    contrato_fechainicio: "",
    contrato_fechafin: "",
  }); // Estado para almacenar los datos del nuevo edificio
  const [showForm, setShowForm] = useState(false); // Estado para controlar la visibilidad del formulario

  // Estados para filtros
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroContrato, setFiltroContrato] = useState("");
  const [busqueda, setBusqueda] = useState("");

  // Estado para ordenamiento genérico: { key, dir } donde dir = "asc" | "desc" | null
  const [sortConfig, setSortConfig] = useState({ key: null, dir: null });

  // Estados para modal de empresas
  const [showModal, setShowModal] = useState(false);
  const [modalEdificio, setModalEdificio] = useState(null);
  const [modalData, setModalData] = useState({
    empresaslistado: "",
    empresasdestacadas: "",
  });

  // Estados para modal de vetos
  const [showVetosModal, setShowVetosModal] = useState(false);
  const [vetosModalEdificio, setVetosModalEdificio] = useState(null);
  const [vetosModalData, setVetosModalData] = useState([]);

  // Estados para modal de contratos
  const [showContratosModal, setShowContratosModal] = useState(false);
  const [showChartModal, setShowChartModal] = useState(false);
  const [contratosModalEdificio, setContratosModalEdificio] = useState(null);
  const [contratosModalData, setContratosModalData] = useState([]);

  // Estados para modal de inversión
  const [showInversionModal, setShowInversionModal] = useState(false);
  const [inversionEdificio, setInversionEdificio] = useState(null);
  const [inversionActivos, setInversionActivos] = useState([]);
  const [inversionProveedores, setInversionProveedores] = useState([]);
  const [inversionLoading, setInversionLoading] = useState(false);
  const [nuevaLinea, setNuevaLinea] = useState(null);

  const { pais, rol } = useAuthContext(); // Extraer el rol del contexto

  // Permisos por rol
  const puedeEditarTodo = rol === ROLES.SUPERADMIN || rol === ROLES.GERENCIA;
  const puedeEditarParcial = rol === ROLES.ADMINISTRATIVO || rol === ROLES.INFRAESTRUCTURA;
  const puedeEditar = puedeEditarTodo || puedeEditarParcial;
  const soloLectura = !puedeEditar;

  const TIPOS_ACTIVO_INVERSION = [
    "pantalla", "reproductor", "soporte", "totem", "antena",
    "costo_instalacion", "insumos_instalacion", "herramientas", "otro",
  ];

  const handleOpenInversionModal = async (edificio) => {
    setInversionEdificio(edificio);
    setShowInversionModal(true);
    setInversionLoading(true);
    try {
      const [activos, provs] = await Promise.all([
        getActivos(pais, { destino_tipo: "edificio", destino_id: edificio.id }),
        getProveedores(pais),
      ]);
      setInversionActivos(activos);
      setInversionProveedores(provs);
    } catch (err) {
      console.error("Error cargando inversiones:", err);
      toast.error("Error cargando inversiones");
    } finally {
      setInversionLoading(false);
    }
  };

  const handleGuardarLinea = async () => {
    if (!nuevaLinea?.tipo_activo || !nuevaLinea?.costo_unitario) {
      toast.error("Tipo y monto son obligatorios");
      return;
    }
    try {
      const activo = await crearActivo({
        pais,
        fecha_compra: nuevaLinea.fecha_planificada || new Date().toISOString().split("T")[0],
        tipo_activo: nuevaLinea.tipo_activo,
        descripcion: nuevaLinea.descripcion || nuevaLinea.tipo_activo,
        cantidad: 1,
        costo_unitario: Number(nuevaLinea.costo_unitario),
        moneda: nuevaLinea.moneda || "CLP",
        vida_util_meses: 60,
        valor_residual: 0,
        estado: "planificado",
        es_planificado: true,
        fecha_planificada: nuevaLinea.fecha_planificada || null,
        destino_tipo: "edificio",
        destino_id: inversionEdificio.id,
        proyecto_nombre: nuevaLinea.proyecto_nombre || null,
        proveedor_id: nuevaLinea.proveedor_id || null,
      });
      setInversionActivos((prev) => [activo, ...prev]);
      setNuevaLinea(null);
      toast.success("Línea agregada");
    } catch (err) {
      console.error("Error al guardar activo:", err, JSON.stringify(err));
      toast.error("Error al guardar: " + (err.message || err));
    }
  };

  const handleEliminarLinea = async (id) => {
    try {
      await eliminarActivo(id);
      setInversionActivos((prev) => prev.filter((a) => a.id !== id));
      toast.success("Línea eliminada");
    } catch {
      toast.error("Error al eliminar");
    }
  };

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  // Estados únicos para filtro
  const estadosUnicos = useMemo(() => {
    return [...new Set(edificios.map((e) => e.estado))].filter(Boolean);
  }, [edificios]);

  // Función helper para verificar si tiene contrato vigente de un tipo
  const tieneContratoVigente = useCallback((contratos, tipo) => {
    if (!contratos || !Array.isArray(contratos)) return false;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    return contratos.some((c) => {
      if (c.tipo !== tipo) return false;
      const fechaFin = new Date(c.fechafin + "T23:59:59");
      const fechaInicio = new Date(c.fechainicio + "T00:00:00");
      return hoy >= fechaInicio && hoy <= fechaFin;
    });
  }, []);

  // Función para ciclar ordenamiento: null → asc → desc → null
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key !== key) return { key, dir: "asc" };
      if (prev.dir === "asc") return { key, dir: "desc" };
      return { key: null, dir: null };
    });
  };

  // Indicador de sort para el header
  const sortIndicator = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.dir === "asc" ? " \u25B2" : " \u25BC";
  };

  // Edificios filtrados
  const edificiosFiltrados = useMemo(() => {
    const filtrados = edificios.filter((edificio) => {
      if (filtroEstado && edificio.estado !== filtroEstado) return false;
      if (busqueda && !edificio.edificio?.toLowerCase().includes(busqueda.toLowerCase())) return false;
      if (filtroContrato && !tieneContratoVigente(edificio.contratos, filtroContrato)) return false;
      return true;
    });

    if (sortConfig.key && sortConfig.dir) {
      filtrados.sort((a, b) => {
        let valA, valB;
        switch (sortConfig.key) {
          case "edificio":
            valA = (a.edificio || "").toLowerCase();
            valB = (b.edificio || "").toLowerCase();
            break;
          case "estado":
            valA = a.estado || "";
            valB = b.estado || "";
            break;
          case "inicio_servicio":
            valA = a.inicio_servicio || "";
            valB = b.inicio_servicio || "";
            break;
          case "personas":
            valA = a.personas || 0;
            valB = b.personas || 0;
            return sortConfig.dir === "asc" ? valA - valB : valB - valA;
          case "estacionamientos":
            valA = a.estacionamientos || 0;
            valB = b.estacionamientos || 0;
            return sortConfig.dir === "asc" ? valA - valB : valB - valA;
          default:
            return 0;
        }
        return sortConfig.dir === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      });
    }

    return filtrados;
  }, [edificios, filtroEstado, filtroContrato, busqueda, tieneContratoVigente, sortConfig]);

  // Estadísticas para el header - conteo por estado
  const estadisticas = useMemo(() => {
    // Orden fijo de estados
    const ordenEstados = ["OPERATIVO", "INSTALACIÓN", "PROYECTO", "STANDBY", "SIN ESTADO"];

    // Contar edificios por estado (usando edificios sin filtrar para el header)
    const conteoPorEstado = {};
    ordenEstados.forEach((estado) => {
      conteoPorEstado[estado] = 0;
    });

    edificios.forEach((e) => {
      const estado = e.estado && e.estado.trim() !== "" ? e.estado : "SIN ESTADO";
      if (conteoPorEstado[estado] !== undefined) {
        conteoPorEstado[estado]++;
      } else {
        // Estado no previsto, agregar a "SIN ESTADO"
        conteoPorEstado["SIN ESTADO"]++;
      }
    });

    return {
      estados: ordenEstados.map((estado) => ({
        nombre: estado,
        cantidad: conteoPorEstado[estado],
      })),
      totalEdificios: edificios.length,
    };
  }, [edificios]);

  // Formatear fecha como "MAY 25" (mes abreviado + año corto)
  const formatMesAnio = (fechaStr) => {
    if (!fechaStr) return "-";
    const date = new Date(fechaStr + "T12:00:00");
    const mes = date.toLocaleDateString("es", { month: "short" }).toUpperCase().replace(".", "");
    const anio = date.toLocaleDateString("es", { year: "2-digit" });
    return `${mes} ${anio}`;
  };

  // Formatear fecha corta
  const formatFecha = (fechaStr) => {
    if (!fechaStr) return "-";
    return new Date(fechaStr + "T12:00:00").toLocaleDateString("es", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  };

  // Formatear porcentaje con 1 decimal según país
  const formatPorcentaje = useCallback(
    (valor) => {
      if (!valor && valor !== 0) return "-";
      const numero = typeof valor === "string" ? parseFloat(valor) : valor;
      return numero.toLocaleString(localString(pais), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
    [localString, pais]
  );

  // Calcular estado de contrato: VIGENTE, POR VENCER (menos de 60 días), VENCIDO
  const getContratoStatus = (contratos, tipo) => {
    if (!contratos || !Array.isArray(contratos)) return null;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // Filtrar contratos del tipo especificado y ordenar por fechafin descendente
    const contratosDelTipo = contratos
      .filter((c) => c.tipo === tipo)
      .sort((a, b) => new Date(b.fechafin) - new Date(a.fechafin));

    if (contratosDelTipo.length === 0) return null;

    // Tomar el contrato más reciente
    const contrato = contratosDelTipo[0];
    const fechaFin = new Date(contrato.fechafin + "T23:59:59");
    const fechaInicio = new Date(contrato.fechainicio + "T00:00:00");

    // Si aún no empezó
    if (hoy < fechaInicio) return { status: "PENDIENTE", color: "#6c757d" };

    // Si ya terminó
    if (hoy > fechaFin) return { status: "VENCIDO", color: "#dc3545" };

    // Calcular días restantes
    const diasRestantes = Math.ceil((fechaFin - hoy) / (1000 * 60 * 60 * 24));

    if (diasRestantes <= 60) {
      return { status: "POR VENCER", color: "#b8860b" }; // Amarillo oscuro (DarkGoldenrod)
    }

    return { status: "VIGENTE", color: "#28a745" };
  };

  // Función reutilizable para obtener edificios y ordenarlos
  const fetchEdificios = async () => {
    try {
      const data = await getEdificios({ pais: propPais || pais });

      // Ordenar los edificios primero por estado y luego por cantidad de personas
      const sortedData = data.sort((a, b) => {
        const estadosOrder = { OPERATIVO: 1, INSTALACIÓN: 2, PROYECTO: 3, STANDBY: 4 };
        // Obtener el orden del estado, si no existe o está vacío, asignar 5 (último)
        const ordenA = a.estado && a.estado.trim() !== "" ? (estadosOrder[a.estado] || 5) : 5;
        const ordenB = b.estado && b.estado.trim() !== "" ? (estadosOrder[b.estado] || 5) : 5;

        if (ordenA !== ordenB) {
          return ordenA - ordenB;
        }
        return (b.personas || 0) - (a.personas || 0);
      });

      setEdificios(sortedData);
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Inicializa categorías y edificios
  useEffect(() => {
    const initialize = async () => {
      const newCategorias = await getCategorias();
      setCategorias(newCategorias);
    };

    initialize();
  }, [pais]);

  // Usa fetchEdificios para cargar datos iniciales
  useEffect(() => {
    fetchEdificios();
  }, [propPais, pais]);

  const handleEditClick = (edificio) => {
    setEditMode(edificio.id);
    // Convertir vetos de string a array de IDs (asumiendo que viene como "id1, id2, id3")
    const vetosArray = edificio.vetos
      ? edificio.vetos.split(",").map((veto) => veto.trim())
      : [];
    setEditedEdificio({
      ...edificio,
      vetos: vetosArray, // Almacenar como array de IDs
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    
    if (name === "personas" || name === "estacionamientos") {
      // Remover cualquier caracter no numérico excepto coma para permitir escritura
      formattedValue = value.replace(/[^\d,]/g, "");
    }
    
    setEditedEdificio({ ...editedEdificio, [name]: formattedValue });
  };

  const handleNewInputChange = (e) => {
    const { name, value } = e.target;
    setNewEdificio({ ...newEdificio, [name]: value });
  };

  const handleAddEdificio = async () => {
    if (!newEdificio.edificio || !newEdificio.estado) {
      toast.error("Nombre y estado son obligatorios.");
      return;
    }

    try {
      const nuevo = {
        ...newEdificio,
        pais, // Agregar el país al objeto del edificio
      };

      // Guardar el edificio en la base de datos
      const savedEdificio = await saveEdificio(nuevo);

      // Agregar el nuevo edificio a la lista local
      setEdificios((prev) => [...prev, savedEdificio]);

      // Limpiar el formulario
      setNewEdificio({
        edificio: "",
        estado: "",
        alianza: "",
        personas: "",
        pantallas: "",
        totems: "",
        espera: "",
        programatica: "Sí",
        estacionamientos: "",
        estacionamientos_ocupacion: "",
        ubicacion: "",
        direccion: "",
        lat: "",
        lng: "",
        empresaslistado: "",
        empresasdestacadas: "",
        vetos: "",
        comision_1_porcentaje: "",
        comision_1_fechainicio: "",
        comision_1_fechafin: "",
        contrato_fechainicio: "",
        contrato_fechafin: "",
      });

      toast.success("Edificio agregado exitosamente.");
    } catch (error) {
      console.error("Error al guardar el edificio:", error);
      toast.error("Error al agregar el edificio.");
    }
  };

  const handleSaveClick = async () => {
    try {
      setLoading(true);
    
      const formattedPersonas =
        typeof editedEdificio.personas === "string"
          ? parseInt(editedEdificio.personas.replace(/,/g, ""), 10) || 0
          : editedEdificio.personas || 0;
    
      const formattedEstacionamientos =
        typeof editedEdificio.estacionamientos === "string"
          ? parseInt(editedEdificio.estacionamientos.replace(/,/g, ""), 10) || 0
          : editedEdificio.estacionamientos || 0;
    
      const formattedVetos = Array.isArray(editedEdificio.vetos)
        ? editedEdificio.vetos.join(", ") // Enviar como string de IDs separados por comas
        : "";
    
      const updatedData = {
        id: editedEdificio.id,
        personas: formattedPersonas,
        estacionamientos: formattedEstacionamientos,
        vetos: formattedVetos,
        empresaslistado: editedEdificio.empresaslistado,
        empresasdestacadas: editedEdificio.empresasdestacadas,
        inicio_servicio: editedEdificio.inicio_servicio || null,
      };
    
      // Actualizar en la base de datos sin asignar a una variable
      await updateEdificio(updatedData);
    
      // Actualizar el estado local inmediatamente
      setEdificios((prevEdificios) =>
        prevEdificios.map((edificio) =>
          edificio.id === editedEdificio.id
            ? {
                ...edificio,
                ...updatedData,
                vetos: formattedVetos, // Aseguramos que vetos se muestre como string
              }
            : edificio
        )
      );
    
      toast.success("Edificio actualizado exitosamente");
    
      // Opcional: Todavía podemos mantener el fetch después de 3 segundos como respaldo
      setTimeout(async () => {
        await fetchEdificios();
      }, 3000);
    } catch (error) {
      console.error("Error al actualizar el edificio:", error);
      toast.error("Error al actualizar el edificio");
    } finally {
      setLoading(false);
      setEditMode(null);
      setEditedEdificio(null);
    }
  };

  const handleCancelClick = () => {
    setEditMode(null); // Sal del modo edición sin guardar
    setEditedEdificio(null);
  };

  // Obtener lista de empresas como array (debe estar antes de early returns)
  const empresasArray = useMemo(() => {
    if (!modalData.empresaslistado) return [];
    return modalData.empresaslistado
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }, [modalData.empresaslistado]);

  // Obtener empresas destacadas como array
  const destacadasArray = useMemo(() => {
    if (!modalData.empresasdestacadas) return [];
    return modalData.empresasdestacadas
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }, [modalData.empresasdestacadas]);

  // Categorías ordenadas alfabéticamente (debe estar antes de early returns)
  const categoriasOrdenadas = useMemo(() => {
    if (!categorias) return [];
    return [...categorias].sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [categorias]);

  // Funciones para modal de empresas
  const handleOpenEmpresasModal = (edificio) => {
    setModalEdificio(edificio);
    setModalData({
      empresaslistado: edificio.empresaslistado || "",
      empresasdestacadas: edificio.empresasdestacadas || "",
    });
    setShowModal(true);
  };

  // Toggle empresa destacada
  const handleToggleDestacada = (empresa) => {
    const isDestacada = destacadasArray.includes(empresa);
    if (isDestacada) {
      // Remover de destacadas
      const newDestacadas = destacadasArray.filter((e) => e !== empresa);
      setModalData((prev) => ({
        ...prev,
        empresasdestacadas: newDestacadas.join(", "),
      }));
    } else {
      // Agregar a destacadas (máximo 5)
      if (destacadasArray.length >= 5) {
        toast.error("Máximo 5 empresas destacadas");
        return;
      }
      setModalData((prev) => ({
        ...prev,
        empresasdestacadas: [...destacadasArray, empresa].join(", "),
      }));
    }
  };

  const handleSaveEmpresasModal = async () => {
    try {
      setLoading(true);
      const updatedData = {
        id: modalEdificio.id,
        personas: modalEdificio.personas,
        estacionamientos: modalEdificio.estacionamientos,
        vetos: modalEdificio.vetos || "",
        empresaslistado: modalData.empresaslistado,
        empresasdestacadas: modalData.empresasdestacadas,
      };
      await updateEdificio(updatedData);
      setShowModal(false);
      toast.success("Empresas actualizadas exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar empresas:", error);
      toast.error("Error al actualizar empresas");
    } finally {
      setLoading(false);
    }
  };

  // Funciones para modal de vetos
  const handleOpenVetosModal = (edificio) => {
    const vetosArray = edificio.vetos ? edificio.vetos.split(",").map((v) => v.trim()) : [];
    setVetosModalEdificio(edificio);
    setVetosModalData(vetosArray);
    setShowVetosModal(true);
  };

  const handleVetosModalChange = (categoriaId) => {
    setVetosModalData((prev) => {
      if (prev.includes(categoriaId)) {
        return prev.filter((id) => id !== categoriaId);
      }
      return [...prev, categoriaId];
    });
  };

  const handleSaveVetosModal = async () => {
    try {
      setLoading(true);
      const formattedVetos = vetosModalData.join(", ");
      const updatedData = {
        id: vetosModalEdificio.id,
        personas: vetosModalEdificio.personas,
        estacionamientos: vetosModalEdificio.estacionamientos,
        vetos: formattedVetos,
        empresaslistado: vetosModalEdificio.empresaslistado || "",
        empresasdestacadas: vetosModalEdificio.empresasdestacadas || "",
      };
      await updateEdificio(updatedData);
      setShowVetosModal(false);
      toast.success("Vetos actualizados exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar vetos:", error);
      toast.error("Error al actualizar vetos");
    } finally {
      setLoading(false);
    }
  };

  // Funciones para modal de contratos
  const handleOpenContratosModal = (edificio) => {
    setContratosModalEdificio(edificio);
    // Parsear contratos existentes o inicializar array vacío
    const contratosExistentes = edificio.contratos || [];
    setContratosModalData(Array.isArray(contratosExistentes) ? contratosExistentes : []);
    setShowContratosModal(true);
  };

  const handleAddContrato = (tipo) => {
    setContratosModalData((prev) => [
      ...prev,
      { tipo, fechainicio: "", fechafin: "" },
    ]);
  };

  const handleRemoveContrato = (index) => {
    setContratosModalData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleContratoChange = (index, field, value) => {
    setContratosModalData((prev) =>
      prev.map((contrato, i) => (i === index ? { ...contrato, [field]: value } : contrato))
    );
  };

  const handleSaveContratosModal = async () => {
    try {
      setLoading(true);
      // Filtrar contratos incompletos (sin fechas)
      const contratosValidos = contratosModalData.filter(
        (c) => c.fechainicio && c.fechafin
      );
      const updatedData = {
        id: contratosModalEdificio.id,
        personas: contratosModalEdificio.personas,
        estacionamientos: contratosModalEdificio.estacionamientos,
        vetos: contratosModalEdificio.vetos || "",
        empresaslistado: contratosModalEdificio.empresaslistado || "",
        empresasdestacadas: contratosModalEdificio.empresasdestacadas || "",
        contratos: contratosValidos,
      };
      await updateEdificio(updatedData);
      setShowContratosModal(false);
      toast.success("Contratos actualizados exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar contratos:", error);
      toast.error("Error al actualizar contratos");
    } finally {
      setLoading(false);
    }
  };

  // Early returns
  if (loading) return <div>Cargando edificios...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className={styles.pageContainer}>
      <Header
        leftContent={
          <div className={styles.statsGrid}>
            {estadisticas.estados.map((item) => (
              <div key={item.nombre} className={styles.statItem}>
                <span className={styles.statLabel}>{item.nombre}:</span>
                <strong className={styles.statValue}>{item.cantidad}</strong>
              </div>
            ))}
          </div>
        }
      >
        <div className={styles.filterRow}>
          <div className={styles.filterItem}>
            <select
              className={styles.filterSelect}
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
            >
              <option value="">Todos los estados</option>
              {estadosUnicos.map((estado, i) => (
                <option key={i} value={estado}>
                  {estado}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.filterItem}>
            <select
              className={`${styles.filterSelect} ${filtroContrato ? styles.activeFilter : ""}`}
              value={filtroContrato}
              onChange={(e) => setFiltroContrato(e.target.value)}
            >
              <option value="">Todos los contratos</option>
              <option value="INVENTARIO">INVENTARIO vigente</option>
              <option value="CARTELERÍA">CARTELERÍA vigente</option>
            </select>
          </div>
          <div className={styles.filterItem}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar edificio..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              style={{ height: "2.5rem", borderRadius: "8px" }}
            />
          </div>
          <button
            className="chart-btn"
            onClick={() => setShowChartModal(true)}
            title="Ver gráfico de crecimiento"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
            Gráfico
          </button>
          {(rol === ROLES.SUPERADMIN || rol === ROLES.GERENCIA) && (
            <button
              className={`btn btn-sm ${showForm ? "btn-warning" : "btn-primary"}`}
              onClick={() => setShowForm((prev) => !prev)}
            >
              {showForm ? "Cancelar" : "+ Edificio"}
            </button>
          )}
        </div>
      </Header>

      <div className={styles.contentWrapper}>
        {showForm && (rol === ROLES.SUPERADMIN || rol === ROLES.GERENCIA) && (
          <div className="row g-3 justify-content-center text-center mb-3">
            <div className="col-md-3">
              <input
                type="text"
                name="edificio"
                placeholder="Nombre"
                value={newEdificio.edificio}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                name="estado"
                placeholder="Estado"
                value={newEdificio.estado}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                name="alianza"
                placeholder="Propietario"
                value={newEdificio.alianza}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="personas"
                placeholder="Personas"
                value={newEdificio.personas}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="pantallas"
                placeholder="Pantallas"
                value={newEdificio.pantallas}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="totems"
                placeholder="Tótems"
                value={newEdificio.totems}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="espera"
                placeholder="Espera"
                value={newEdificio.espera}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="estacionamientos"
                placeholder="Estacionamientos"
                value={newEdificio.estacionamientos}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="estacionamientos_ocupacion"
                placeholder="Ocupación estacionamientos"
                value={newEdificio.estacionamientos_ocupacion}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                name="ubicacion"
                placeholder="Ubicación"
                value={newEdificio.ubicacion}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                name="direccion"
                placeholder="Dirección"
                value={newEdificio.direccion}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="lat"
                placeholder="Latitud"
                value={newEdificio.lat}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="lng"
                placeholder="Longitud"
                value={newEdificio.lng}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                name="empresaslistado"
                placeholder="Empresas listado"
                value={newEdificio.empresaslistado}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>     
            <div className="col-md-3">
              <input
                type="text"
                name="empresasdestacadas"
                placeholder="Empresas destacadas"
                value={newEdificio.empresasdestacadas}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="text"
                name="vetos"
                placeholder="Vetos"
                value={newEdificio.vetos}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="number"
                name="comision_1_porcentaje"
                placeholder="Comisión (%)"
                value={newEdificio.comision_1_porcentaje}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="date"
                name="comision_1_fechainicio"
                placeholder="Inicio contrato"
                value={newEdificio.comision_1_fechainicio}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <input
                type="date"
                name="comision_1_fechafin"
                placeholder="Fin comisión"
                value={newEdificio.comision_1_fechafin}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label small mb-0">Inicio Contrato</label>
              <input
                type="date"
                name="contrato_fechainicio"
                value={newEdificio.contrato_fechainicio}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label small mb-0">Fin Contrato</label>
              <input
                type="date"
                name="contrato_fechafin"
                value={newEdificio.contrato_fechafin}
                onChange={handleNewInputChange}
                className="form-control form-control-sm"
              />
            </div>
            <div className="col-md-12 text-center mb-3">
              <button className="btn btn-primary" onClick={handleAddEdificio}>
                Agregar
              </button>
            </div>
          </div>
        )}

        <table className={`table table-bordered table-striped table-hover small text-sm ${styles.edificiosTable}`}>
          <thead>
            <tr className="table-dark text-center">
              <th style={{ width: "18%" }} className={styles.sortableHeader} onClick={() => handleSort("edificio")}>
                NOMBRE{sortIndicator("edificio")}
              </th>
              <th style={{ width: "9%" }} className={styles.sortableHeader} onClick={() => handleSort("estado")}>
                STATUS{sortIndicator("estado")}
              </th>
              <th style={{ width: "7%" }} className={styles.sortableHeader} onClick={() => handleSort("inicio_servicio")}>
                INICIO{sortIndicator("inicio_servicio")}
              </th>
              <th style={{ width: "7%" }} className={styles.sortableHeader} onClick={() => handleSort("personas")}>
                PERSONAS{sortIndicator("personas")}
              </th>
              <th style={{ width: "7%" }} className={styles.sortableHeader} onClick={() => handleSort("estacionamientos")}>
                PARKING{sortIndicator("estacionamientos")}
              </th>
              <th style={{ width: "12%" }}>CONTRATO</th>
              <th style={{ width: "16%" }}>COMISIONES</th>
              <th style={{ width: "24%" }}>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            {edificiosFiltrados.map((edificio) => (
              <tr key={edificio.id}>
                {editMode === edificio.id ? (
                  <>
                    <td style={{ textAlign: "left" }}>
                      {edificio.edificio ? edificio.edificio.toUpperCase() : "-"}
                    </td>
                    <td
                      style={{
                        backgroundColor:
          edificio.estado === "OPERATIVO"
            ? "green"
            : edificio.estado === "INSTALACIÓN"
              ? "red"
              : edificio.estado === "PROYECTO"
                ? "blue"
                : "black",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      {edificio.estado}
                    </td>
                    {/* INICIO SERVICIO (editable) */}
                    <td>
                      <input
                        type="date"
                        name="inicio_servicio"
                        value={editedEdificio.inicio_servicio || ""}
                        onChange={handleInputChange}
                        style={{ height: "20px", width: "100%", fontSize: "11px" }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="personas"
                        value={editedEdificio.personas.toLocaleString(localString(pais), {
                          maximumFractionDigits: 0,
                          minimumFractionDigits: 0,
                        })}
                        onChange={handleInputChange}
                        style={{
                          height: "20px",
                          width: "80px",
                          textAlign: "right",
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="estacionamientos" // Corregido de "personas" a "estacionamientos"
                        value={
                          editedEdificio.estacionamientos !== undefined && editedEdificio.estacionamientos !== null
                            ? editedEdificio.estacionamientos.toLocaleString(localString(pais), {
                              maximumFractionDigits: 0,
                              minimumFractionDigits: 0,
                            })
                            : ""
                        }
                        onChange={handleInputChange}
                        style={{
                          height: "20px",
                          width: "80px",
                          textAlign: "right",
                        }}
                      />
                    </td>
                    {/* CONTRATO (solo lectura) */}
                    <td style={{ fontSize: "10px", verticalAlign: "middle", textAlign: "center" }}>
                      {(() => {
                        const statusInv = getContratoStatus(editedEdificio.contratos, "INVENTARIO");
                        const statusCart = getContratoStatus(editedEdificio.contratos, "CARTELERÍA");
                        if (!statusInv && !statusCart) {
                          return <span style={{ color: "#999" }}>-</span>;
                        }
                        return (
                          <>
                            {statusInv && (
                              <div style={{ color: statusInv.color, fontWeight: "bold" }}>
                                PUBLICIDAD: {statusInv.status}
                              </div>
                            )}
                            {statusCart && (
                              <div style={{ color: statusCart.color, fontWeight: "bold" }}>
                                CARTELERÍA: {statusCart.status}
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </td>
                    {/* COMISIONES (solo lectura) */}
                    <td style={{ fontSize: "12px", textAlign: "center" }}>
                      {editedEdificio.comision_1_porcentaje && (
                        <div
                          style={{
                            paddingBottom: editedEdificio.comision_2_porcentaje ? "5px" : "0",
                            marginBottom: editedEdificio.comision_2_porcentaje ? "5px" : "0",
                            borderBottom: editedEdificio.comision_2_porcentaje ? "1px solid #e0e0e0" : "none",
                          }}
                        >
                          {formatPorcentaje(editedEdificio.comision_1_porcentaje)}% del{" "}
                          {formatFecha(editedEdificio.comision_1_fechainicio)} al{" "}
                          {formatFecha(editedEdificio.comision_1_fechafin)}
                        </div>
                      )}
                      {editedEdificio.comision_2_porcentaje && (
                        <div
                          style={{
                            paddingBottom: editedEdificio.comision_3_porcentaje ? "5px" : "0",
                            marginBottom: editedEdificio.comision_3_porcentaje ? "5px" : "0",
                            borderBottom: editedEdificio.comision_3_porcentaje ? "1px solid #e0e0e0" : "none",
                          }}
                        >
                          {formatPorcentaje(editedEdificio.comision_2_porcentaje)}% del{" "}
                          {formatFecha(editedEdificio.comision_2_fechainicio)} al{" "}
                          {formatFecha(editedEdificio.comision_2_fechafin)}
                        </div>
                      )}
                      {editedEdificio.comision_3_porcentaje && (
                        <div>
                          {formatPorcentaje(editedEdificio.comision_3_porcentaje)}% del{" "}
                          {formatFecha(editedEdificio.comision_3_fechainicio)} al{" "}
                          {formatFecha(editedEdificio.comision_3_fechafin)}
                        </div>
                      )}
                      {!editedEdificio.comision_1_porcentaje &&
                        !editedEdificio.comision_2_porcentaje &&
                        !editedEdificio.comision_3_porcentaje &&
                        "-"}
                    </td>
                    {/* ACCIONES - modo edición */}
                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                      <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                        <button
                          onClick={handleSaveClick}
                          className="btn btn-success btn-sm"
                          style={{ fontSize: "10px", padding: "4px 10px" }}
                        >
                          GUARDAR
                        </button>
                        <button
                          onClick={handleCancelClick}
                          className="btn btn-danger btn-sm"
                          style={{ fontSize: "10px", padding: "4px 10px" }}
                        >
                          CANCELAR
                        </button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td style={{ textAlign: "left" }}>
                      {edificio.edificio ? edificio.edificio.toUpperCase() : "-"}
                    </td>
                    <td
                      style={{
                        backgroundColor:
          edificio.estado === "OPERATIVO"
            ? "green"
            : edificio.estado === "INSTALACIÓN"
              ? "red"
              : edificio.estado === "PROYECTO"
                ? "blue"
                : "black",
                        color: "white",
                        textAlign: "center",
                      }}
                    >
                      {edificio.estado}
                    </td>
                    {/* INICIO SERVICIO */}
                    <td>
                      {formatMesAnio(edificio.inicio_servicio)}
                    </td>
                    <td>
                      {edificio.personas
                        ? edificio.personas.toLocaleString(localString(pais), {
                          maximumFractionDigits: 0,
                          minimumFractionDigits: 0,
                        })
                        : "-"}
                    </td>
                    <td>
                      {edificio.estacionamientos !== undefined && edificio.estacionamientos !== null
                        ? edificio.estacionamientos.toLocaleString(localString(pais), {
                          maximumFractionDigits: 0,
                          minimumFractionDigits: 0,
                        })
                        : "-"}
                    </td>
                    {/* CONTRATO */}
                    <td>
                      {(() => {
                        const statusInv = getContratoStatus(edificio.contratos, "INVENTARIO");
                        const statusCart = getContratoStatus(edificio.contratos, "CARTELERÍA");
                        if (!statusInv && !statusCart) {
                          return <span style={{ color: "#999" }}>-</span>;
                        }
                        return (
                          <>
                            {statusInv && (
                              <div style={{ color: statusInv.color, fontWeight: "bold" }}>
                                PUBLICIDAD: {statusInv.status}
                              </div>
                            )}
                            {statusCart && (
                              <div style={{ color: statusCart.color, fontWeight: "bold" }}>
                                CARTELERÍA: {statusCart.status}
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </td>
                    {/* COMISIONES */}
                    <td style={{ fontSize: "12px", textAlign: "center" }}>
                      {edificio.comision_1_porcentaje && (
                        <div
                          style={{
                            paddingBottom: edificio.comision_2_porcentaje ? "5px" : "0",
                            marginBottom: edificio.comision_2_porcentaje ? "5px" : "0",
                            borderBottom: edificio.comision_2_porcentaje ? "1px solid #e0e0e0" : "none",
                          }}
                        >
                          {formatPorcentaje(edificio.comision_1_porcentaje)}% del{" "}
                          {formatFecha(edificio.comision_1_fechainicio)} al {formatFecha(edificio.comision_1_fechafin)}
                        </div>
                      )}
                      {edificio.comision_2_porcentaje && (
                        <div
                          style={{
                            paddingBottom: edificio.comision_3_porcentaje ? "5px" : "0",
                            marginBottom: edificio.comision_3_porcentaje ? "5px" : "0",
                            borderBottom: edificio.comision_3_porcentaje ? "1px solid #e0e0e0" : "none",
                          }}
                        >
                          {formatPorcentaje(edificio.comision_2_porcentaje)}% del{" "}
                          {formatFecha(edificio.comision_2_fechainicio)} al {formatFecha(edificio.comision_2_fechafin)}
                        </div>
                      )}
                      {edificio.comision_3_porcentaje && (
                        <div>
                          {formatPorcentaje(edificio.comision_3_porcentaje)}% del{" "}
                          {formatFecha(edificio.comision_3_fechainicio)} al {formatFecha(edificio.comision_3_fechafin)}
                        </div>
                      )}
                      {!edificio.comision_1_porcentaje &&
                        !edificio.comision_2_porcentaje &&
                        !edificio.comision_3_porcentaje &&
                        "-"}
                    </td>
                    {/* ACCIONES - 5 botones con permisos */}
                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                      {soloLectura ? (
                        <span style={{ color: "#999", fontSize: "10px" }}>Solo lectura</span>
                      ) : (
                        <div style={{ display: "flex", gap: "3px", justifyContent: "center", flexWrap: "wrap" }}>
                          {puedeEditarTodo && (
                            <>
                              <button
                                className="btn btn-info btn-sm"
                                style={{ fontSize: "9px", padding: "2px 5px", color: "white" }}
                                onClick={() => handleOpenContratosModal(edificio)}
                                title="Editar Contratos"
                              >
                                CONTRATO
                              </button>
                              <button
                                className="btn btn-warning btn-sm"
                                style={{ fontSize: "9px", padding: "2px 5px", color: "white" }}
                                onClick={() => toast("Funcionalidad de comisiones próximamente", { icon: "ℹ️" })}
                                title="Editar Comisiones"
                              >
                                COMISIÓN
                              </button>
                              <button
                                className="btn btn-success btn-sm"
                                style={{ fontSize: "9px", padding: "2px 5px", color: "white" }}
                                onClick={() => handleOpenInversionModal(edificio)}
                                title="Planificar inversión"
                              >
                                INVERSIÓN
                              </button>
                            </>
                          )}
                          {puedeEditar && (
                            <>
                              <button
                                className="btn btn-primary btn-sm"
                                style={{ fontSize: "9px", padding: "2px 5px", color: "white" }}
                                onClick={() => handleOpenEmpresasModal(edificio)}
                                title="Editar Empresas"
                              >
                                EMPRESAS
                              </button>
                              <button
                                className="btn btn-secondary btn-sm"
                                style={{ fontSize: "9px", padding: "2px 5px", color: "white" }}
                                onClick={() => handleOpenVetosModal(edificio)}
                                title="Editar Vetos"
                              >
                                VETOS
                              </button>
                              <button
                                className="btn btn-dark btn-sm"
                                style={{ fontSize: "9px", padding: "2px 5px", color: "white" }}
                                onClick={() => handleEditClick(edificio)}
                                title="Editar Datos"
                              >
                                DATA
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </td>
                  </>
                )}

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal para editar Empresas - 2 columnas */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Empresas - {modalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>Lista de Empresas</strong> (separadas por coma)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                value={modalData.empresaslistado}
                onChange={(e) => setModalData({ ...modalData, empresaslistado: e.target.value })}
                style={{ textTransform: "uppercase" }}
                placeholder="EMPRESA1, EMPRESA2, EMPRESA3..."
              />
            </Form.Group>

            <div style={{ display: "flex", gap: "20px" }}>
              {/* Columna izquierda - Todas las empresas con checkboxes */}
              <div style={{ flex: 1 }}>
                <Form.Label>
                  <strong>Seleccionar Destacadas</strong>
                  <span style={{ color: "#666", fontSize: "12px", marginLeft: "8px" }}>
                    (marcar hasta 5)
                  </span>
                </Form.Label>
                <div
                  style={{
                    maxHeight: "350px",
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  {empresasArray.length > 0 ? (
                    empresasArray.map((empresa, idx) => (
                      <Form.Check
                        key={idx}
                        type="checkbox"
                        id={`empresa-${idx}`}
                        label={empresa.toUpperCase()}
                        checked={destacadasArray.includes(empresa)}
                        onChange={() => handleToggleDestacada(empresa)}
                        style={{ marginBottom: "4px" }}
                      />
                    ))
                  ) : (
                    <span style={{ color: "#999" }}>Ingrese empresas arriba</span>
                  )}
                </div>
              </div>

              {/* Columna derecha - Empresas destacadas */}
              <div style={{ flex: 1 }}>
                <Form.Label>
                  <strong>Empresas Destacadas</strong>
                  <span style={{ color: destacadasArray.length >= 5 ? "red" : "#666", fontSize: "12px", marginLeft: "8px" }}>
                    ({destacadasArray.length}/5)
                  </span>
                </Form.Label>
                <div
                  style={{
                    minHeight: "350px",
                    border: "1px solid #28a745",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  {destacadasArray.length > 0 ? (
                    destacadasArray.map((empresa, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "6px 8px",
                          backgroundColor: "white",
                          borderRadius: "4px",
                          marginBottom: "4px",
                          border: "1px solid #28a745",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>{empresa.toUpperCase()}</span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          style={{ fontSize: "10px", padding: "2px 6px" }}
                          onClick={() => handleToggleDestacada(empresa)}
                        >
                          ×
                        </button>
                      </div>
                    ))
                  ) : (
                    <span style={{ color: "#999" }}>Ninguna empresa destacada</span>
                  )}
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveEmpresasModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar Vetos - Categorías ordenadas alfabéticamente */}
      <Modal show={showVetosModal} onHide={() => setShowVetosModal(false)} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>Vetos - {vetosModalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ color: "#666", marginBottom: "15px" }}>
            Seleccione las categorías que desea vetar para este edificio:
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "4px 10px",
              maxHeight: "600px",
              overflowY: "auto",
              padding: "15px 25px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          >
            {categoriasOrdenadas.map((categoria) => {
              const isSelected = vetosModalData.includes(categoria.id.toString());
              return (
                <Form.Check
                  key={categoria.id}
                  type="checkbox"
                  id={`veto-modal-${categoria.id}`}
                  label={
                    <span
                      style={{
                        backgroundColor: isSelected ? "#ffebee" : "transparent",
                        color: isSelected ? "#c62828" : "inherit",
                        padding: "1px 4px",
                        borderRadius: "3px",
                        fontWeight: isSelected ? 500 : 400,
                      }}
                    >
                      {categoria.nombre}
                    </span>
                  }
                  checked={isSelected}
                  onChange={() => handleVetosModalChange(categoria.id.toString())}
                  style={{
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                />
              );
            })}
          </div>
          <div style={{ marginTop: "10px", color: "#666" }}>
            <strong>Vetos seleccionados:</strong> {vetosModalData.length}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVetosModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveVetosModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar Contratos */}
      <Modal show={showContratosModal} onHide={() => setShowContratosModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Contratos - {contratosModalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", gap: "30px" }}>
            {/* Sección INVENTARIO */}
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <strong style={{ color: "#0d6efd" }}>INVENTARIO PUBLICITARIO</strong>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleAddContrato("INVENTARIO")}
                  style={{ fontSize: "11px" }}
                >
                  + Agregar
                </Button>
              </div>
              <div style={{ border: "1px solid #0d6efd", borderRadius: "4px", padding: "10px", minHeight: "200px" }}>
                {contratosModalData
                  .map((contrato, index) => ({ ...contrato, originalIndex: index }))
                  .filter((c) => c.tipo === "INVENTARIO")
                  .map((contrato) => (
                    <div
                      key={contrato.originalIndex}
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Inicio</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechainicio}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechainicio", e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Fin</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechafin}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechafin", e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveContrato(contrato.originalIndex)}
                          style={{ fontSize: "10px", padding: "4px 8px", marginTop: "18px" }}
                        >
                          ×
                        </Button>
                      </div>
                    </div>
                  ))}
                {contratosModalData.filter((c) => c.tipo === "INVENTARIO").length === 0 && (
                  <span style={{ color: "#999", fontSize: "12px" }}>Sin contratos de inventario</span>
                )}
              </div>
            </div>

            {/* Sección CARTELERÍA */}
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <strong style={{ color: "#198754" }}>CARTELERÍA DIGITAL</strong>
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => handleAddContrato("CARTELERÍA")}
                  style={{ fontSize: "11px" }}
                >
                  + Agregar
                </Button>
              </div>
              <div style={{ border: "1px solid #198754", borderRadius: "4px", padding: "10px", minHeight: "200px" }}>
                {contratosModalData
                  .map((contrato, index) => ({ ...contrato, originalIndex: index }))
                  .filter((c) => c.tipo === "CARTELERÍA")
                  .map((contrato) => (
                    <div
                      key={contrato.originalIndex}
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Inicio</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechainicio}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechainicio", e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Fin</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechafin}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechafin", e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveContrato(contrato.originalIndex)}
                          style={{ fontSize: "10px", padding: "4px 8px", marginTop: "18px" }}
                        >
                          ×
                        </Button>
                      </div>
                    </div>
                  ))}
                {contratosModalData.filter((c) => c.tipo === "CARTELERÍA").length === 0 && (
                  <span style={{ color: "#999", fontSize: "12px" }}>Sin contratos de cartelería</span>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowContratosModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveContratosModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Inversión */}
      <Modal
        show={showInversionModal}
        onHide={() => {
          setShowInversionModal(false);
          setNuevaLinea(null);
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Inversión — {inversionEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {inversionLoading ? (
            <div style={{ textAlign: "center", padding: 40 }}>Cargando...</div>
          ) : (
            <>
              <table className="table table-sm table-bordered" style={{ fontSize: "0.82rem" }}>
                <thead className="table-dark">
                  <tr>
                    <th style={{ width: "18%" }}>Tipo</th>
                    <th style={{ width: "22%" }}>Proveedor</th>
                    <th style={{ width: "8%" }}>Moneda</th>
                    <th style={{ width: "16%", textAlign: "right" }}>Monto</th>
                    <th style={{ width: "14%" }}>Fecha</th>
                    <th style={{ width: "12%" }}>Estado</th>
                    <th style={{ width: "10%" }} />
                  </tr>
                </thead>
                <tbody>
                  {inversionActivos.length === 0 && !nuevaLinea && (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center", color: "#999", padding: 30 }}>
                        Sin inversiones registradas para este edificio
                      </td>
                    </tr>
                  )}
                  {inversionActivos.map((a) => (
                    <tr key={a.id} style={{ background: a.es_planificado ? "#fff9e6" : "#f0fff0" }}>
                      <td>{a.tipo_activo}</td>
                      <td>{a.proveedor?.nombre || inversionProveedores.find((p) => p.id === a.proveedor_id)?.nombre || "—"}</td>
                      <td>{a.moneda}</td>
                      <td style={{ textAlign: "right" }}>
                        {Number(a.costo_unitario).toLocaleString("es-CL")}
                      </td>
                      <td>{a.fecha_planificada || a.fecha_compra || "—"}</td>
                      <td>
                        <span
                          style={{
                            fontSize: "0.7rem",
                            padding: "2px 6px",
                            borderRadius: 3,
                            background: a.es_planificado ? "#fff3cd" : "#d4edda",
                            color: a.es_planificado ? "#856404" : "#155724",
                          }}
                        >
                          {a.es_planificado ? "Planificado" : "Ejecutado"}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {a.es_planificado && (
                          <button
                            className="btn btn-outline-danger btn-sm"
                            style={{ fontSize: "10px", padding: "1px 6px" }}
                            onClick={() => handleEliminarLinea(a.id)}
                          >
                            ×
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}

                  {nuevaLinea && (
                    <tr style={{ background: "#e8f4fd" }}>
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={nuevaLinea.tipo_activo || ""}
                          onChange={(e) => setNuevaLinea((p) => ({ ...p, tipo_activo: e.target.value }))}
                        >
                          <option value="">Tipo...</option>
                          {TIPOS_ACTIVO_INVERSION.map((t) => (
                            <option key={t} value={t}>
                              {t}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={nuevaLinea.proveedor_id || ""}
                          onChange={(e) =>
                            setNuevaLinea((p) => ({
                              ...p,
                              proveedor_id: e.target.value ? parseInt(e.target.value, 10) : null,
                            }))
                          }
                        >
                          <option value="">Proveedor...</option>
                          {inversionProveedores.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.nombre}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          className="form-select form-select-sm"
                          value={nuevaLinea.moneda || "CLP"}
                          onChange={(e) => setNuevaLinea((p) => ({ ...p, moneda: e.target.value }))}
                        >
                          <option value="CLP">CLP</option>
                          <option value="USD">USD</option>
                          <option value="UF">UF</option>
                        </select>
                      </td>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          type="number"
                          placeholder="Monto"
                          value={nuevaLinea.costo_unitario || ""}
                          onChange={(e) => setNuevaLinea((p) => ({ ...p, costo_unitario: e.target.value }))}
                          style={{ textAlign: "right" }}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          type="date"
                          value={nuevaLinea.fecha_planificada || ""}
                          onChange={(e) => setNuevaLinea((p) => ({ ...p, fecha_planificada: e.target.value }))}
                        />
                      </td>
                      <td colSpan={2} style={{ whiteSpace: "nowrap" }}>
                        <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                          <button
                            className="btn btn-success btn-sm"
                            style={{ fontSize: "10px" }}
                            onClick={handleGuardarLinea}
                          >
                            ✓
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            style={{ fontSize: "10px" }}
                            onClick={() => setNuevaLinea(null)}
                          >
                            ×
                          </button>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {inversionActivos.length > 0 && (() => {
                const totalPlanCLP = inversionActivos
                  .filter((a) => a.es_planificado && a.moneda !== "USD")
                  .reduce((s, a) => s + Number(a.costo_unitario), 0);
                const totalPlanUSD = inversionActivos
                  .filter((a) => a.es_planificado && a.moneda === "USD")
                  .reduce((s, a) => s + Number(a.costo_unitario), 0);
                const totalEjeCLP = inversionActivos
                  .filter((a) => !a.es_planificado && a.moneda !== "USD")
                  .reduce((s, a) => s + Number(a.costo_unitario), 0);
                return (
                  <div style={{ textAlign: "right", fontSize: "0.85rem", marginTop: 8 }}>
                    <strong>Planificado: </strong>
                    {totalPlanCLP.toLocaleString("es-CL")} CLP
                    {totalPlanUSD > 0 && ` + US$ ${totalPlanUSD.toLocaleString("es-CL")}`}
                    {" | "}
                    <strong>Ejecutado: </strong>
                    {totalEjeCLP.toLocaleString("es-CL")} CLP
                  </div>
                );
              })()}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            size="sm"
            onClick={() =>
              setNuevaLinea({
                tipo_activo: "",
                descripcion: "",
                moneda: "CLP",
                costo_unitario: "",
                fecha_planificada: "",
                proyecto_nombre: "",
                proveedor_id: null,
              })
            }
            disabled={!!nuevaLinea}
          >
            + Agregar línea
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setShowInversionModal(false);
              setNuevaLinea(null);
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Chart Modal - Crecimiento Red */}
      <EdificiosChartModal
        open={showChartModal}
        onClose={() => setShowChartModal(false)}
        edificios={edificios}
      />
    </div>
  );
};

export default EdificiosTable;
